import mitt from 'mitt'

// 创建事件总线实例
const bus = mitt()

// 导出事件总线实例
export default bus
